import { CompactToolbar } from '../../core/slots/toolbar/CompactToolbar.js';
import { DISPLAY_NAME } from '../constants.js';

export const GaugeChartToolbarSlot = CompactToolbar(DISPLAY_NAME);
